<template>
    <div id="contenedor-principal-clinicas">
        <CCargandoInformacion v-if="cargandoInformacion" :mostrarError="ocurrioError"></CCargandoInformacion>
        <div v-if="!cargandoInformacion">
            <div v-if="this.campoRequeridoEsValido(datosArea)" id="titulo-area">
                <h1>{{ this.campoRequeridoEsValido(datosArea.titulo) ? datosArea.titulo : 'Clinicas' }}</h1>
                <h3>{{ datosArea.subtitulo }}</h3>
                <div class="hr-titulo"/>
            </div>
            <!-- <CMenuHorizontal></CMenuHorizontal> -->
            <CSeccion v-for="(seccion) in secciones" :key="'seccion-' + seccion.SeccionId" 
                class="espacio-entre-secciones"
                :informacion="{ idElemento: seccion.SeccionId, nombre: seccion.Nombre }"
                :formatosDeSeccion="[{ tipoDeFormato: seccion.FormatoId, contenidos: seccion.Contenidos }]"
                :opciones="{ tiposDocumentoArea: tiposDocumentosArea, ListadoDeDocumentos: listaDeClinicas, esClinica: true}"
                :ref="SECCIONES.REF"></CSeccion>
        </div>
    </div>
</template>
<script>
import router from '@/router/index'
import CSeccion from "@/components/Intranet/Comun/CSeccion.vue";
import api from '@/../static/js/api'
import comun from "@/../static/js/comun"
import CCargandoInformacion from "@/components/Intranet/Comun/CCargandoInformacion";
import axios from 'axios'

export default {
    components: {
        CSeccion: CSeccion,
        CCargandoInformacion: CCargandoInformacion
    },
    beforeRouteEnter (to, from, next) {
        const VISTA_RAIZ = 'Inicio';
        next(async (instanciaVue) => {
            instanciaVue.cargandoInformacion = true;
            const PAGINA_HABILITADA = await Promise.resolve(instanciaVue.usuarioTieneLaPaginaHabilitada({ ruta: to.path }));
            if(!PAGINA_HABILITADA) {
                router.push({ name: VISTA_RAIZ});
                instanciaVue.cargandoInformacion = false;
                comun.mensajeDeAlerta('No tienes acceso a la pagina solicitada', null, null);
            }
        });
    },
    data() {
        return {
            secciones: [],
            datosArea: {  titulo: null, subtitulo: null },
            tiposDocumentosArea: [],
            listaDeClinicas: {
                opciones: {
                    paddingDefault: { aplicar: false, css: 'padding: 9vmin 0 11vmin 0 !important;' },
                    filtrosBusqueda: { mostrar: false },
                    titulo: { mostrar: true, nombre: 'Lista de clinicas' },
                    tiposDeDocumentos: []
                }
            },
            TIEMPO_CLINICAS: {
                inicio: 2010,
                numeroDeHistorial: 10
            },
            tiemposSesiones: [],
            tiempoSeleccionado: -1,
            TIPOS_CONVERSION_CONTENIDOS: {
                /* NOTA: CREAR FUNCION PARA OBTENER LOS ENCABEZADOS Y AGREGAR VALIDACION EN FOR DE CONVERSION DE CONTENIDOS */
                // AVISOS
                32: ({ contenido }) => {
                    const { ContenidoDeIntreanetId, TextoDelContenido } = contenido;
                    const { Ruta } = contenido.ArchivosDeContenidoIntranet[0];
                    let contenidoObj = {};
                    contenidoObj.id = ContenidoDeIntreanetId;
                    contenidoObj.Titulo = TextoDelContenido;
                    contenidoObj.RutaDeAcceso = Ruta;
                    contenidoObj.Descripcion = TextoDelContenido;
                    return contenidoObj;
                },
                // MATERIAL
                39: ({ contenido }) => {
                    const { TextoDelVinculo, TextoDelContenido, Vinculo, ArchivosDeContenidoIntranet } = contenido;
                    let contenidoObj = {};
                    contenidoObj.icono = 'fas fa-toolbox';
                    contenidoObj.nombre = TextoDelVinculo;
                    contenidoObj.RutaDeAcceso = this.campoRequeridoEsValido(Vinculo) ? Vinculo : ArchivosDeContenidoIntranet[0].Ruta;
                    contenidoObj.esDescarga = !this.campoRequeridoEsValido(Vinculo);
                    return contenidoObj;
                },
                // DOCUMENTOS
                37: ({ contenido }) => { 
                    const { FechaDeRegistro, TextoDelContenido, ContenidoAlQuePertenece, UsuarioQueRegistro, SesionDeClinicaIntranet, ArchivosDeContenidoIntranet, TipoDeClinica, FechaDePublicacion } = contenido;
                    const { Ruta, NombreBase } = ArchivosDeContenidoIntranet[0];
                    let contenidoObj = {};
                    //{ Nombre: 'Sesión No.1', Fecha: '21 de enero', Persona: 'LIC. HUGO BERNARDO MÁRQUEZ ELÍAS' },
                    const ES_SESION_PENAL = this.campoRequeridoEsValido(SesionDeClinicaIntranet);
                    if(ES_SESION_PENAL) {
                        moment.locale('es-es');
                        const { Titulo, Fecha, TextoDeSesion } = SesionDeClinicaIntranet;
                        contenidoObj.Nombre = Titulo;
                        contenidoObj.Fecha = this.darFormatoAFechaDeSesionPenal({ fecha: Fecha });
                        contenidoObj.FechaCompleta = Fecha;
                        contenidoObj.Persona = TextoDeSesion;
                        contenidoObj.OrdenDelDia = ArchivosDeContenidoIntranet.find(a => a.TextoDelVinculo == 'Orden del día').Ruta;
                        contenidoObj.Ponencia = ArchivosDeContenidoIntranet.find(a => a.TextoDelVinculo == 'Ponencia').Ruta;
                        contenidoObj.ActaDeLaSesion = ArchivosDeContenidoIntranet.find(a => a.TextoDelVinculo == 'Acta de la sesión.').Ruta;
                        contenidoObj.esSesionPenal = ES_SESION_PENAL;
                    }
                    else {
                        contenidoObj.Titulo = TextoDelContenido;
                        contenidoObj.RutaParaAccesar = Ruta;
                        contenidoObj.Archivo = NombreBase;
                        contenidoObj.Nombre = TextoDelContenido;
                        contenidoObj.Extension = NombreBase.split('.').pop().toUpperCase();
                        contenidoObj.Fecha = moment(FechaDePublicacion).format('YYYY-MM-DD');;
                        contenidoObj.Tipo = TipoDeClinica.Nombre.split(' ')[TipoDeClinica.Nombre.split(' ').length - 1];
                        contenidoObj.InicialesUsuario = UsuarioQueRegistro.Nombre.charAt(0).toUpperCase() + UsuarioQueRegistro.ApellidoMaterno.charAt(0).toUpperCase();
                        contenidoObj.usuario = UsuarioQueRegistro.Nombre + ' ' +UsuarioQueRegistro.ApellidoMaterno;
                        contenidoObj.esSesionPenal = ES_SESION_PENAL;
                        //contenidoObj.ContenidoAlQuePerteneceId = ContenidoAlQuePertenece.ContenidoDeIntreanetId;
                    }
                    return contenidoObj;
                }
            },
            FORMATOS: {
                SESIONES_PENALES: 40
            },
            SECCIONES: {
                LISTA_CLINICAS: {
                    ID: 43,
                    NOMBRE: 'Lista de clinicas'
                },
                REF: 'REFSeccionesClinicas-INTRANET'
            },
            listadoDeClinicasTMP: [],
            cargandoInformacion: true,
            ocurrioError: false
        }
    },
    methods: {
        usuarioTieneLaPaginaHabilitada: async function({ ruta }) {
            let habilitada = false;
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.SICPO.sistema.intranet.paginaintranet.VerificarSiTieneHabilitadaPagina;
                const SERVICIO_REST = SERVIDOR + METODO_API_OBTENER;
                let peticion = { 
                    RutaDePagina: this.obtenerPrefijoBaseDeLaRuta({ rutaDeLaPaginaDeIntranet: ruta })
                };
                let peticionArchivos = false;
                let HEADER_PETICION = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
                const RESPUESTA_PETICION = await axios.post(SERVICIO_REST, peticion, HEADER_PETICION);
                const DATOS_RESPUESTA = await RESPUESTA_PETICION.data;
                let { SiHayError, Error, TieneHabilitadaLaPagina } = DATOS_RESPUESTA;
                if (SiHayError) {
                    console.log(Error);
                } 
                else {
                    habilitada = TieneHabilitadaLaPagina
                }
            }
            catch(excepcion) {
                console.log(excepcion);
            }
            return habilitada;
        },
        // SECCION PARA FUNCIONES
        iniciarProcesoCargaDeInformacion: async function() { 
            try {
                this.cargandoInformacion = true;
                const CARGO_CONTENIDOS_SIN_ERROR = await Promise.resolve(this.obtenerPaginaConSeccionesYContenidosBD());
                this.cargandoInformacion = !(CARGO_CONTENIDOS_SIN_ERROR);
                this.ocurrioError = this.cargandoInformacion;
                console.log('formatos::',this.secciones);
                $('html, body').animate({ scrollTop:0 }, 'slow');
            }
            catch(excepcion) {
                console.log(excepcion);
            }
        },
        obtenerPaginaConSeccionesYContenidosBD: async function() {
            let procesoSinError = false;
            console.log('route::',this.$route)
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.SICPO.sistema.intranet.paginaintranet.ObtenerContenidosDeIntranetAdministracion;
                const SERVICIO_REST = SERVIDOR + METODO_API_OBTENER;
                let peticion = { 
                    RutaDeLaPaginaDeIntranet: this.obtenerPrefijoBaseDeLaRuta({ rutaDeLaPaginaDeIntranet: this.$route.fullPath }), 
                    PorAreaDeUsuario: true,
                    EsPrueba: false 
                };
                let peticionArchivos = false;
                let HEADER_PETICION = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
                const RESPUESTA_PETICION = await axios.post(SERVICIO_REST, peticion, HEADER_PETICION);
                const DATOS_RESPUESTA = await RESPUESTA_PETICION.data;
                let { SiHayError, Error, PaginaDeIntranet } = DATOS_RESPUESTA;
                if (SiHayError) {
                    console.log(Error);
                } 
                else {
                    console.log('objPagina::',PaginaDeIntranet);
                    await Promise.resolve(this.convertirContenidosAObjetosDeFormatos({ pagina: PaginaDeIntranet }));
                    procesoSinError = true;
                }
            }
            catch(excepcion) {
                console.log(excepcion);
            }
            return procesoSinError;
        },
        obtenerPrefijoBaseDeLaRuta: function({ rutaDeLaPaginaDeIntranet }) { 
            let rutaBase = rutaDeLaPaginaDeIntranet;
            let elementosRuta = rutaDeLaPaginaDeIntranet.split('/');
            if(this.campoRequeridoEsValido(elementosRuta)) {
                // 1 parametros a eliminar para obtener la ruta base
                elementosRuta.pop();
                rutaBase = elementosRuta.join('/');
            }
            return rutaBase;
        },
        convertirContenidosAObjetosDeFormatos: async function({ pagina }) { 
            if(this.campoRequeridoEsValido(pagina)) {
                const { SeccionesDeIntranet } = pagina;
                if(this.campoRequeridoEsValido(SeccionesDeIntranet)) {
                    this.secciones = SeccionesDeIntranet.map(sBD => {
                        let seccionObj = {};
                        seccionObj.SeccionId = sBD.SeccionDeIntranetId;
                        seccionObj.Nombre = sBD.Nombre;
                        const ES_SESION_PENAL = (this.campoRequeridoEsValido(sBD.Contenidos) && sBD.Contenidos.some(c => this.campoRequeridoEsValido(c.SesionDeClinicaIntranet)));
                        seccionObj.FormatoId = (ES_SESION_PENAL) ? this.FORMATOS.SESIONES_PENALES : sBD.TipoFormato.TipoFormatoId;

                        if(this.campoRequeridoEsValido(sBD.SeccionesQueMePertenecen))
                            this.asignarEncabezadosDeArea({ secciones: sBD.SeccionesQueMePertenecen });
        
                        let contenidosDeSeccionObj = sBD.Contenidos.map((cBD) => {
                            let contenidoObj = this.TIPOS_CONVERSION_CONTENIDOS[sBD.TipoFormato.TipoFormatoId]({ contenido: cBD });
                            return contenidoObj;
                        });
                        seccionObj.Contenidos = contenidosDeSeccionObj;
                        return seccionObj;
                    });
                }
            }
        },
        asignarEncabezadosDeArea: function({ secciones }) { 
            const SECCION_TITULO_ID = 38;
            const SECCION_SUBTITULO_ID = 39;
            this.datosArea = {};
            secciones.forEach(s => {
                if(s.SeccionDeIntranetId == SECCION_TITULO_ID)
                    this.datosArea.titulo = (this.campoRequeridoEsValido(s.Contenidos)) ? s.Contenidos[0].TextoDelContenido : '';
                else if(s.SeccionDeIntranetId == SECCION_SUBTITULO_ID)
                    this.datosArea.subtitulo = (this.campoRequeridoEsValido(s.Contenidos)) ? s.Contenidos[0].TextoDelContenido : '';
            });
        },
        cambioTiempo: function(evento) { 
            this.tiempoSeleccionado = parseInt(evento.target.value);
        },
        /* esMateriaPenal: async function(ruta) { 
            const REFERENCIA_CLINICA = 'PENAL';
            let esPenal = false;
            if(this.campoRequeridoEsValido(ruta)) {
                esPenal = ruta.toUpperCase().includes(REFERENCIA_CLINICA);
            }
            return esPenal;
        }, */
        darFormatoAFechaDeSesionPenal: function({ fecha }) {
            let fechaConFormato = '';
            const MES = (moment(fecha).format('MMMM'));
            const DIA = moment(fecha).date();
            fechaConFormato = `${ DIA } de ${ MES }`;
            return fechaConFormato;
        },
        campoRequeridoEsValido: function(campo) { 
            let esValido = false
            if(typeof campo === 'string' || campo instanceof String) {
                // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
                if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'number' || campo instanceof Number) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo > 0) {
                    esValido = true;
                }
            }
            else {
                if (campo != null && campo != undefined) {
                    esValido = true;
                }
            }
            return esValido;
        }
    },
    async created() { 
        await Promise.resolve(this.iniciarProcesoCargaDeInformacion());
        /* const URL_CLINICAS = router.history.current.path;
        const ES_MATERIA_PENAL = await Promise.resolve(this.esMateriaPenal(URL_CLINICAS));
        // buscar en bd las secciones del area
        this.secciones = [
            { 
                SeccionId: 1,
                Nombre: 'Avisos',
                FormatoId: 32,
                Contenidos: [
                    { Titulo: 'Imagen 1', RutaDeAcceso: 'http://189.206.207.232:85/Files/SICPO/Pagina Oficial/19/31/2020/Noviembre/1550/Convocatoria CJE_ 05_2020.jpg', Descripcion: 'Descripcion imagen 1' },
                    { Titulo: 'Imagen 2', RutaDeAcceso: 'http://189.206.207.232:85/files/sicpo/Pagina Oficial/21/42/2020/Septiembre/741/fotonota10.jpeg', Descripcion: 'Descripcion imagen 2' },
                    { Titulo: 'Imagen 3', RutaDeAcceso: 'http://189.206.207.232:85/files/sicpo/Pagina Oficial/21/42/2020/Septiembre/741/fotonota10.jpeg', Descripcion: 'Descripcion imagen 3' }   
                ]
            },
            { SeccionId: 6, Nombre: 'Formulario envio de edictos', FormatoId: 39, Contenidos: [
                { icono: 'fas fa-layer-group', nombre: 'Lineamientos' },
                { icono: 'fas fa-calendar-minus', nombre: 'Calendario' }
            ] } , */
          /*   { SeccionId: 7, Nombre: 'Sesiones', FormatoId: 40, Contenidos: [
                { Nombre: 'Sesión No.1', Fecha: '21 de enero', Persona: 'LIC. HUGO BERNARDO MÁRQUEZ ELÍAS' },
                { Nombre: 'Sesión No.2', Fecha: '22 de enero', Persona: 'LIC. HUGO BERNARDO MÁRQUEZ ELÍAS' },
                { Nombre: 'Sesión No.3', Fecha: '23 de enero', Persona: 'LIC. HUGO BERNARDO MÁRQUEZ ELÍAS' },
                { Nombre: 'Sesión No.4', Fecha: '24 de enero', Persona: 'LIC. HUGO BERNARDO MÁRQUEZ ELÍAS' },
                { Nombre: 'Sesión No.5', Fecha: '25 de enero', Persona: 'LIC. HUGO BERNARDO MÁRQUEZ ELÍAS' },
                { Nombre: 'Sesión No.6', Fecha: '26 de enero', Persona: 'LIC. HUGO BERNARDO MÁRQUEZ ELÍAS' },
                { Nombre: 'Sesión No.7', Fecha: '27 de enero', Persona: 'LIC. HUGO BERNARDO MÁRQUEZ ELÍAS' },
            ] }  */
        /* ];

        if(ES_MATERIA_PENAL)
            this.secciones.push(  { SeccionId: 7, Nombre: 'Sesiones', FormatoId: 40, Contenidos: [
                    { Nombre: 'Sesión No.1', Fecha: '21 de enero', Persona: 'LIC. HUGO BERNARDO MÁRQUEZ ELÍAS' },
                    { Nombre: 'Sesión No.2', Fecha: '22 de enero', Persona: 'LIC. HUGO BERNARDO MÁRQUEZ ELÍAS' },
                    { Nombre: 'Sesión No.3', Fecha: '23 de enero', Persona: 'LIC. HUGO BERNARDO MÁRQUEZ ELÍAS' },
                    { Nombre: 'Sesión No.4', Fecha: '24 de enero', Persona: 'LIC. HUGO BERNARDO MÁRQUEZ ELÍAS' },
                    { Nombre: 'Sesión No.5', Fecha: '25 de enero', Persona: 'LIC. HUGO BERNARDO MÁRQUEZ ELÍAS' },
                    { Nombre: 'Sesión No.6', Fecha: '26 de enero', Persona: 'LIC. HUGO BERNARDO MÁRQUEZ ELÍAS' },
                    { Nombre: 'Sesión No.7', Fecha: '27 de enero', Persona: 'LIC. HUGO BERNARDO MÁRQUEZ ELÍAS' },
                ] } );
        else
            this.secciones.push( { SeccionId: 4, Nombre: 'Documentos de area', FormatoId: 37, Contenidos: [
                { Titulo: 'Clínica Procesal Civil 2013', RutaParaAccesar: '/Intranet/Inicio', Descripcion: 'enlace 1', Nombre: 'Clínica Procesal penal 2013', Extension: 'PDF', Mb: '120', Fecha: '01/01/0001', Tipo: 'Nota' },
                { Titulo: 'Clínica Procesal Civil 2014', RutaParaAccesar: '/Intranet/Inicio', Descripcion: 'enlace 1', Nombre: 'Clínica Procesal penal 2014', Extension: 'PDF', Mb: '120', Fecha: '01/01/0001', Tipo: 'Nota' },
                { Titulo: 'Clínica Procesal Civil 2015', RutaParaAccesar: '/Intranet/Inicio', Descripcion: 'enlace 1', Nombre: 'Clínica Procesal penal 2015', Extension: 'PDF', Mb: '120', Fecha: '01/01/0001', Tipo: 'Nota' },
                { Titulo: 'Clínica Procesal Civil 2016', RutaParaAccesar: '/Intranet/Inicio', Descripcion: 'enlace 1', Nombre: 'Clínica Procesal penal 2016', Extension: 'PDF', Mb: '120', Fecha: '01/01/0001', Tipo: 'Nota' },
                { Titulo: 'Clínica Procesal Civil 2017', RutaParaAccesar: '/Intranet/Inicio', Descripcion: 'enlace 1', Nombre: 'Clínica Procesal penal 2017', Extension: 'PDF', Mb: '120', Fecha: '01/01/0001', Tipo: 'Nota' },
                { Titulo: 'Clínica Procesal Civil 2018', RutaParaAccesar: '/Intranet/Inicio', Descripcion: 'enlace 1', Nombre: 'Clínica Procesal penal 2018', Extension: 'PDF', Mb: '120', Fecha: '01/01/0001', Tipo: 'Nota' }
            ] }); */
    },
    watch: {
        '$store.state.Login_PermisosDelSistema': function() {
            console.log('permisos::',this.$store.state.Login_PermisosDelSistema);
        }
    }
}
</script>
<style scoped>
#i-cambio-fecha {
    font-size: 3.5vmin;
    color: black;
    cursor: pointer;
}

#modal-cambio-fecha .modal-lg {
    max-width: 35% !important;
    z-index: 9999999999999999999999999999999999999;
}

#modal-cambio-fecha .modal-content {
    background-color: #FFFFFF;
    box-shadow: 0px 6px 20px 8px #424242;
}

#modal-cambio-fecha .modal-content .form-control{
    background-color: white;
    color: rgb(63, 62, 62);
    border: 1px solid #656161 !important;
    height: 2.5em;
}

#modal-cambio-fecha .modal-header {
    background-color: rgb(49, 49, 49);
    border: none;
    color: white;
    display: flex;
    align-items: center;
}

#acciones-modal h6 {
    color: rgb(49, 49, 49) !important;
    font-weight: bold;
    cursor: pointer;
}

#acciones-modal h6:hover, #acciones-modal h6:focus {
    color: #be9a5e !important;
}

#acciones-modal {
    margin-top: 2em;
}


#modal-cambio-fecha .modal-header i {
    font-size: 2em;
}

#modal-cambio-fecha .modal-dialog {
  position: relative;
  top: 40%;
  transform: translateY(-50%);
}



#modal-cambio-fecha h3 {
    color: #676666;
    font-size: 2.4em;
    font-weight: bold;
    margin-bottom: -1px;
}

#modal-cambio-fecha h6 {
    color: #A08F8F;
    font-size: 1.4em;
    margin-bottom: 1.5em;
}

#modal-cambio-fecha .btn-primary {
    background-color: #50A728;
}

.espacio-entre-secciones {
    margin-top: 3vmin;
}

#contenedor-principal-clinicas {
    padding: 7vmin 16vmin 0vmin 16vmin;
}

#titulo-area h1 {
    font-size: 5vmin;
    font-weight: bold;
    color: #0f0f0f;
    margin-bottom: 0;
}

#titulo-area {
    margin-bottom: 3em;
}

#titulo-area h3 {
    font-size: 2.5vmin;
    color: #8d8d8d;
}

.hr-titulo {
    height:0.5em;
    width: 6em;
    border:none;
    background-color:#be9a5e;
}
</style>


// WEBPACK FOOTER //
// src/components/Intranet/Areas/CClinicas.vue